import React, { useState, useEffect } from 'react';
import PARSE from 'html-react-parser';
import { useSelector } from 'react-redux';
import Api from './Api';

function SSoft_Privacy_Policy() {
  const [sectionItems, setSectionItems] = useState([]);
  const activeLang = useSelector((state) => state.content.activeLanguage);

  useEffect(() => {
    const fetchData = async () => {
      const api = new Api();
      const sectionResponse = await api.getSectionDetail({ language: activeLang });
      const sectionData = sectionResponse.data.results[0].widgets[0];

      setSectionItems(sectionData?.widget_contents[0]?.article_language.content);
    };

    fetchData();
  }, [activeLang]);

  return (
    <div className='section-container section-margin-x w-full h-full py-[80px] lg:py-[120px]'>
      <div 
        className={'mdl:px-[100px] prose max-w-none prose-h2:pb-[10px] prose-headings:font-inter prose-headings:text-2xl prose-headings:font-semibold' +
        'prose-li:leading-[130%] prose-li:mb-0 prose-li:font-inter prose-li:text-[20px] prose-p:text-[20px] prose-p:font-inter'}
      >
        {typeof sectionItems === 'string' && PARSE(sectionItems)}
      </div>
    </div>
  );
}

export default SSoft_Privacy_Policy